export default __webpack_public_path__ + "static/media/ico-telegram-24.a684bc1e.svg";